define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CloudFileModel = /** @class */ (function () {
        function CloudFileModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.FileName = ko.observable();
            this.CloudUrl = ko.observable();
            this.Category = ko.observable();
            this.FileGroup = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CloudFileModel.Mapping, self);
            }
        }
        CloudFileModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CloudFileModel(options.data);
            }
        };
        return CloudFileModel;
    }());
    return CloudFileModel;
});
//# sourceMappingURL=CloudFileModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CloudFileModel.js
// module id = 316
// module chunks = 2